<template>
    <div class="mt-26">
        <div class="text-center text-16 font-medium underline mb-4">
            เงื่อนไขและข้อตกลง
        </div>
        <div>
            <ConsentBox :config="consentMiscUrl" />
        </div>
        <div class="my-2.5">
            <Checkbox v-model:check="acceptTerms" text="ยอมรับเงื่อนไขและข้อตกลง" :customClass="`text-14`" />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useBlob } from '@/helper/useBlob';
// component
import ConsentBox from '../Consent/ConsentBox.vue';
import Checkbox from '@/components/Input/simple/Checkbox.vue';

export default defineComponent({
    props: {
        modelValue: {
            type: Boolean
        }
    },
    emits: ["checkTerms", "update:modelValue"],
    setup: function (props, ctx) {
        const consentMiscUrl = ref()
        const acceptTerms = computed({
            get: function () {
                return props.modelValue
            },
            set: function (val) {
                ctx.emit("update:modelValue", val)
            }
        })
        const blob = useBlob()
        blob.loadAppConfig("/config.json").then(config => {
            // console.log(config)
            consentMiscUrl.value = config.consent_text_url
        })

        const checkTerms = function () {
            console.log("check terms")
            return acceptTerms.value
        }

        ctx.expose({
            checkTerms
        })

        return {
            acceptTerms,
            consentMiscUrl,
            checkTerms
        }
    },
    components: {
        Checkbox,
        ConsentBox
    }
})
</script>


